import type {
  userFilterJSONDTOSchema,
  userFilterSchema,
  userInviteFilterJSONDTOSchema,
  userInviteFilterSchema,
  userInviteSortableFields,
  userSortableFields,
} from '@tempo-io/id-dto';
import type { z } from 'zod';

export const userManagementQueryKeys = {
  users: {
    all: (queryKeyParams: {
      sortBy?: (typeof userSortableFields)[number];
      sortOrder?: 'asc' | 'desc';
      filterBy?: z.output<typeof userFilterJSONDTOSchema>;
    }) => ['userManagement', 'users', queryKeyParams],
    count: (orgId: string, filterBy?: z.infer<typeof userFilterSchema>) => [
      'userManagement',
      'users',
      'count',
      { orgId, filterBy },
    ],
    byIds: (userIds: string[]) => ['userManagement', 'users', 'byIds', [...userIds].sort()],
    byId: (userId: string) => ['userManagement', 'users', 'byId', userId] as const,
  },
  invites: {
    all: (queryKeyParams: {
      sortBy: (typeof userInviteSortableFields)[number];
      sortOrder: 'asc' | 'desc';
      filterBy?: z.output<typeof userInviteFilterJSONDTOSchema>;
    }) => ['userManagement', 'invites', queryKeyParams],
    count: (orgId: string, filterBy?: z.infer<typeof userInviteFilterSchema>) => [
      'userManagement',
      'invites',
      'count',
      { orgId, filterBy },
    ],
  },
  userManagement: {
    profile: (userId: string) => ['userManagement', 'user', userId, 'profile'],
  },
  profile: () => ['current-user-profile'],
  memberships: () => ['current-user-memberships'],
};
